import request from "@/router/axios";

// 获取巡检任务列表
export const getList = (data) => {
  return request({
    url: "/api/produce/inspection-worko-rder/select/page",
    method: "post",
    data,
  });
};

// 新增巡检任务
export const exportExcel = (data) => {
  return request({
    url: "/api/produce/inspection-worko-rder/export/excel",
    method: "post",
    data,
    responseType: "blob",
  });
};

export const add = (row) => {
  return request({
    url: "/api/produce/inspection-worko-rder/insert",
    method: "post",
    data: row,
  });
};

// 获取巡检任务详情
export const getDetail = (id) => {
  return request({
    url: "/api/produce/inspection-worko-rder/select/id",
    method: "get",
    params: {
      id,
    },
  });
};

// 更新巡检任务
export const update = (row) => {
  return request({
    url: "/api/produce/inspection-worko-rder/update",
    method: "post",
    data: row,
  });
};

// 删除巡检任务
export const remove = (ids) => {
  return request({
    url: "/api/produce/inspection-worko-rder/delete/ids",
    method: "get",
    params: {
      ids,
    },
  });
};

// 启动定时任务 - 创建今日任务
export const createTodayTasks = () => {
  return request({
    url: "/api/produce/inspection-task-job/create-today-tasks",
    method: "post",
  });
};
